import { apiHelper } from "./core"
const baseUrl = process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const baseUrlResource = process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL,
  masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL
const reportingServiceBaseUrl = process.env.REACT_APP_REPORTING_BASE_URL

const getReports = (report: any, category: any, filtersApplied :any): Promise<any> => {
  // report="Patients Report"
  return apiHelper.post(
    `${reportingServiceBaseUrl}/report/get?name=${report}&category=${category}`,
    filtersApplied
  )
}

const getAllReportsList = (report: any): Promise<any> => {
  return apiHelper.get(
    `${reportingServiceBaseUrl}/report/category?categoryName=${report}`
  )
}

const sendEmailReports = (reportName:any,iframe:any,values:any,category: any,exportoptions:any, isEmail: any): Promise<any> => {
  return apiHelper
    .post(
      `${reportingServiceBaseUrl}/report/generate?reportName=${reportName}&reportCategory=${category}&isPdfFormatRequired=false&isXlsxFormatRequired=true&isEmail=${isEmail}`,
      values
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getPersonaCategories = (): Promise<any> => {
  return apiHelper.get(
    `${reportingServiceBaseUrl}/report/moc-role?mocRole=SYSTEM_ADMIN`
  )
}

const getPoolingTime = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/moc-master`)
    .then((res: any) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  getReports,
  getAllReportsList,
  sendEmailReports,
  getPersonaCategories,
  getPoolingTime,
}
